import React from "react";
import "./EditorLeftMenuImageBackgroundControls.css";
import BackgroundImageControlsMenu from "./BackgroundImageControlsMenu";

const EditorLeftMenuImageBackgroundControls = ({
  onApplyImageBackground = () => {},
  onViewingCategoryChange = () => {},
  onUnsplashSearch,
  onUnsplashTrackDownload,
}) => {
  const [activeMenu, setActiveMenu] = React.useState("Image");

  const handleViewingCategoryChange = (isViewing) => {
    onViewingCategoryChange(isViewing);
  };

  return (
    <div className="image-background-controls-container">
      {activeMenu === "Image" && (
        <BackgroundImageControlsMenu
          onApplyImageBackground={onApplyImageBackground}
          onViewingCategoryChange={handleViewingCategoryChange}
          onUnsplashSearch={onUnsplashSearch}
          onUnsplashTrackDownload={onUnsplashTrackDownload}
        />
      )}
    </div>
  );
};

export default EditorLeftMenuImageBackgroundControls;
